import React from 'react';

export default function OfflinePage() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <rect width="80" height="80" rx="16" fill="#3E2C6E" opacity="0.1"/>
            <path d="M40 20v20l10 10" stroke="#E0A526" strokeWidth="3" strokeLinecap="round"/>
            <circle cx="40" cy="40" r="16" stroke="#E0A526" strokeWidth="3" fill="none"/>
            <path d="M25 25l30 30" stroke="#3E2C6E" strokeWidth="3" strokeLinecap="round" opacity="0.4"/>
          </svg>
        </div>
        <h1 style={styles.title}>لا يوجد اتصال بالإنترنت</h1>
        <p style={styles.desc}>
          يبدو أنك غير متصل بالشبكة. بعض الصفحات قد لا تعمل حالياً.
          <br />
          حاول الاتصال بالإنترنت وحاول مرة أخرى.
        </p>
        <button style={styles.retryBtn} onClick={() => window.location.reload()}>
          إعادة المحاولة
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--color-bg, #f5f5f5)',
    padding: 'var(--sp-lg, 16px)',
    direction: 'rtl'
  },
  card: {
    textAlign: 'center',
    maxWidth: '360px',
    padding: 'var(--sp-3xl, 32px)',
    backgroundColor: '#fff',
    borderRadius: 'var(--radius-lg, 12px)',
    boxShadow: 'var(--shadow-lg, 0 4px 16px rgba(0,0,0,0.1))'
  },
  iconWrap: {
    marginBottom: 'var(--sp-xl, 20px)'
  },
  title: {
    fontSize: 'var(--font-size-xl, 22px)',
    color: 'var(--color-primary, #3E2C6E)',
    fontWeight: 700,
    margin: '0 0 var(--sp-md, 12px)'
  },
  desc: {
    fontSize: 'var(--font-size-base, 14px)',
    color: 'var(--color-text-secondary, #666)',
    lineHeight: 1.6,
    margin: '0 0 var(--sp-2xl, 24px)'
  },
  retryBtn: {
    padding: 'var(--sp-md, 12px) var(--sp-3xl, 32px)',
    fontSize: 'var(--font-size-md, 16px)',
    fontWeight: 600,
    color: '#fff',
    backgroundColor: 'var(--color-primary, #3E2C6E)',
    border: 'none',
    borderRadius: 'var(--radius-md, 8px)',
    cursor: 'pointer',
    transition: 'opacity var(--transition-fast, 0.15s)'
  }
};
